import styled from 'styled-components';

import colors from 'apps/promo/theme/colors';
import fonts from 'apps/promo/theme/fonts';
import media from 'apps/promo/theme/media';

const getLabelColor = (props) => {
    if (!props.$isFocused && !props.$isError) {
        return colors.mediumGray;
    } else if (props.$isFocused && !props.$isError) {
        return colors.purple;
    } else if (props.$isError) {
        return colors.red;
    } else {
        return colors.mediumGray;
    }
};
const getBorderColor = (props) => {
    if (!props.$isFocused && !props.$isError) {
        return colors.greyRgba28;
    } else if (props.$isFocused && !props.$isError) {
        return colors.purple;
    } else if (props.$isError) {
        return colors.red;
    } else {
        return colors.lightGray;
    }
};

export const InputContainer = styled.div`
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
    border: 1px solid ${colors.greyRgba28};
    border-bottom: ${(props) => `1px solid ${getBorderColor(props)}`};
    border-radius: 6px;
    pointer-events: ${(props) => (props.$isReadOnly ? 'none' : null)};
    opacity: ${(props) => (props.$isReadOnly ? '0.4' : null)};
    background: ${(props) => (props.$hasWhiteBg ? colors.white : null)};

    &:after {
        content: '';
        position: absolute;
        width: calc(100% - 4px);
        height: 1px;
        background: ${(props) => (!props.$isFocused && !props.$isError ? null : getBorderColor(props))};
        bottom: 0;
        left: 2px;

        ${media.desktop1920} {
            height: 2px;
        }
    }
`;

export const InputLabel = styled.label`
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    padding: 16px;
    cursor: ${(props) => (props.$isPseudoSelect ? 'pointer' : null)};
    z-index: 1;

    ${media.desktop1920} {
        padding: 20px 24px;
    }

    input,
    input[type='search'],
    textarea {
        font-family: ${fonts.gtStandardMMedium};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        background-color: transparent;
        border: none;
        box-sizing: border-box;
        display: inline-block;
        padding: ${(props) => (props.$isPseudoSelect ? '0 24px 0 0' : '0')};
        width: 100%;
        font-size: 17px;
        line-height: 24px;
        text-overflow: ellipsis;
        cursor: ${(props) => (props.$isPseudoSelect ? 'pointer' : 'auto')};
        outline: none;

        &:-webkit-autofill {
            -webkit-box-shadow: inset 0 0 0 50px ${colors.white} !important;
            -webkit-text-fill-color: ${colors.black} !important;
            color: ${colors.black} !important;
        }

        ${media.desktop1920} {
            padding: ${(props) => (props.$isPseudoSelect ? '0 28px 0 0' : '0')};
            font-size: 20px;
            line-height: 32px;
        }
    }
`;

export const FloatingLabel = styled.span`
    position: absolute;
    top: ${(props) => (props.$isFilled || props.$isFocused ? '-12px' : '16px')};
    left: 8px;
    font-size: ${(props) => (props.$isFilled || props.$isFocused ? '14px' : '17px')};
    line-height: ${(props) => (props.$isFilled || props.$isFocused ? '20px' : '24px')};
    color: ${(props) => getLabelColor(props)};
    transition: top 0.2s;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: calc(100% - 16px);
    box-sizing: border-box;
    padding: 0 8px;
    background: ${colors.white};
    border-radius: 4px;

    ${media.desktop1920} {
        top: ${(props) => (props.$isFilled || props.$isFocused ? '-14px' : '20px')};
        left: 16px;
        font-size: ${(props) => (props.$isFilled || props.$isFocused ? '17px' : '20px')};
        line-height: ${(props) => (props.$isFilled || props.$isFocused ? '24px' : '32px')};
    }
`;

export const HintContainer = styled.div`
    margin-top: 8px;
    padding: 0 16px;
    text-align: ${(props) => (props.$commentCenter ? 'center' : 'left')};
    display: flex;

    ${media.desktop1920} {
        padding: 0 24px;
    }
`;

export const HintButton = styled.span`
    margin-top: -4px;
    margin-left: 2px;
`;

export const InputRightElement = styled.div`
    position: absolute;
    right: ${(props) => (props.$isInfoButtonForPseudoselect ? '46px' : '16px')};
    top: 14px;
    z-index: 1;

    ${media.desktop1920} {
        right: ${(props) => (props.$isInfoButtonForPseudoselect ? '54px' : '16px')};
        top: 18px;
    }
`;
